<template>
	<div class="meidum-b">
		<!-- <div class="meidumz">
			<div class="ry-cc">
				<div class="ry-b">
					
				</div>
			    
				<el-carousel :interval="0" arrow="always" indicator-position="none">
				    <el-carousel-item  v-for="item in list" :key="item">
						<div class="ry-b-c">
							<div class="item" v-for="item1 in item" 
							style="" @click="tapDetails(item1)">
								<div class="t">{{item1.createTime.substring(0, 10)}}</div>
								<div class="s11" style="display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制为3行 */
    -webkit-box-orient: vertical;
    overflow: hidden;">{{item1.barticleTile}}</div>
								<img class="item-h" :src="item1.barticleUrl" alt="">
							</div>
						</div>
				    </el-carousel-item>
				  </el-carousel>
			</div>
		</div> -->
		<div class="medium-cc">
			<div class="medium-c1"> 
				<div class="medium-c-item" v-for="(item, index) in list" :key="index">
					<div class="medium-c-item-l">
						<div class="medium-c-item-l-top">
							{{item.createTime.substring(0, 4)}} 
						</div>
						<div v-if="list.length-1 != index" class="medium-c-item-l-bottom"></div>
					</div>
					<div class="medium-c-item-b">
						
					</div>
					<div class="medium-c-item-r">
						<div class="medium-c-item-r-r">
							<div class="medium-c-item-r-r-top">
								{{item.barticleTile}}
							</div>
							<div class="medium-c-item-r-r-top1">
								{{item.createTime.split('00:00:00')[0]}}
							</div>
							<div class="medium-c-item-r-r-bottom">
								{{item.content1}}
							</div>
						</div>
						<img class="medium-c-item-r-l" :src="item.barticleUrl" alt="" />
					</div>
				</div>
			</div>
		</div>
		
		
		
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			},
			

		},
		data() {
			return {
				selectIndex: 0

			}
		},
		created() {

		},
		methods: {
			tapList(index) {
				this.selectIndex = index
			},
			tapDetails(item) {
				this.$router.push({path:"/en/mediumdetails", query:{ id: item.bid }}) 
			}

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
	
	.medium-cc {
		width: 100%;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		.medium-c1 {
			
			.medium-c-item {
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				// align-items: center;
				// padding-bottom: 60px;
				.medium-c-item-l {
					flex-direction: column;
					justify-content: flex-start;
					align-items: center;
					.medium-c-item-l-top {
						width: 100%;
						background-color: #22A3D3;
						text-align: center;
						color: white;
					}
					.medium-c-item-l-bottom {
						width: 1px;
						background-color: #22A3D3;
					}
					
				}
				.medium-c-item-b {
					height: 1px;
					background-color: #22A3D3;
				}
				.medium-c-item-r {
					background-color: rgba(34, 163, 211, 0.05);
					background-color: aliceblue;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					.medium-c-item-r-r {
						width:100%;
						.medium-c-item-r-r-top {
							font-family: AlibabaPuHuiTi-Medium;
							font-weight: 500;
							color: #333333;
						}
						
						.medium-c-item-r-r-bottom {
							font-family: AlibabaPuHuiTi-Regular;
							font-weight: 400;
							color: #333333;
							display: -webkit-box;
							    -webkit-box-orient: vertical;
							    -webkit-line-clamp: 5;
							    overflow: hidden;
						}
						
					}
					img {
	
					}
					
				}
				
			}
			
		}
	}
	
	@media screen and (min-width: 1200px) {
		.medium-cc {
			width: 100%;
			padding: 80px 0;
			.medium-c1 {
				width: 1200px;
				
				.medium-c-item {
					width: 1200px;
					.medium-c-item-l {
						display: flex;
						width: 150px;
						.medium-c-item-l-top {
							width: 100%;
							height: 60px;
							line-height: 60px;
							font-size: 24px;
						}
						.medium-c-item-l-bottom {
							width: 1px;
							height: calc(100% - 60px);
						}
						
					}
					.medium-c-item-b {
						width: 72px;
						margin-top: 30px;
					}
					.medium-c-item-r {
						// width: calc(100% - 225px);
						width:100%;
						// height: 260px;
						padding: 30px 45px;
						margin-bottom: 30px;
						.medium-c-item-r-r {
							
							.medium-c-item-r-r-top {
								font-size: 20px;
							}
							.medium-c-item-r-r-top1 {
								margin-top: 12px;
								font-size: 16px;
							}
							
							.medium-c-item-r-r-bottom {
								margin-top: 20px;
								font-size: 20px;
							}
							
						}
						img {
							width: 300px;
							height: 200px;
							object-fit: cover;
						}
						
					}
					
				}
				
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.medium-cc {
			width: 100%;
			padding: 60px 0;
			.medium-c1 {
				width: 100%;
				
				.medium-c-item {
					width: 100%;
					.medium-c-item-l {
						display: flex;
						width: 120px;
						.medium-c-item-l-top {
							width: 100%;
							height: 50px;
							line-height: 50px;
							font-size: 20px;
						}
						.medium-c-item-l-bottom {
							width: 1px;
							height: calc(100% - 50px);
						}
						
					}
					.medium-c-item-b {
						width: 60px;
						margin-top: 25px;
					}
					.medium-c-item-r {
						width: calc(100% - 180px);
						// height: 230px;
						padding: 20px 32px;
						margin-bottom: 20px;
						.medium-c-item-r-r {
							
							.medium-c-item-r-r-top {
								font-size: 18px;
							}
							.medium-c-item-r-r-top1 {
								margin-top: 15px;
								font-size: 14px;
							}
							
							.medium-c-item-r-r-bottom {
								margin-top: 18px;
								font-size: 18px;
							}
							
						}
						img {
							width: 240px;
							height: 160px;
						}
						
					}
					
				}
				
			}
		}
	}
	@media screen and (max-width: 880px) {
		.medium-cc {
			width: 100%;
			padding: 60px 0;
			.medium-c1 {
				width: 100%;
				
				.medium-c-item {
					width: 100%;
					margin-bottom: 10px;
					.medium-c-item-l {
						display: none;
						
					}
					.medium-c-item-b {
						display: none;
					}
					.medium-c-item-r {
						width: calc(100% - 20px);
						// height: 140px;
						margin-left: 10px;
						padding: 12px 16px;
						.medium-c-item-r-r {
							width: 70%;
							.medium-c-item-r-r-top {
								font-size: 15px;
							}
							.medium-c-item-r-r-top1 {
								margin-top: 10px;
								font-size: 12px;
							}
							
							.medium-c-item-r-r-bottom {
								margin-top: 12px;
								font-size: 15px;
							}
							
						}
						img {
							width: 30%;
							height: 80%;
						}
						
					}
					
				}
				
			}
		}
	}
	
	// .el-carousel__item h3 {
	//     color: #475669;
	//     font-size: 14px;
	//     opacity: 0.75;
	//     line-height: 200px;
	//     margin: 0;
	//   }
	  
	//   .el-carousel__item:nth-child(2n) {
	//     background-color: rgba(0, 0, 0, 0);
	//   }
	  
	//   .el-carousel__item:nth-child(2n+1) {
	//     background-color: rgba(0, 0, 0, 0);
	//   }

   
	
	// .meidumz {
	// 	background-color: #fff;
	// 	flex-direction: column;
	// 	align-items: center;
	// 	box-sizing: border-box;

	// 	.ry-cc {
			
	// 	}

	// 	// .ry-b {
			
	// 	// 	align-items: center;

	// 	// 	.ry-b-l,
	// 	// 	.ry-b-r {
	// 	// 		cursor: pointer;
				
	// 	// 	}
			
			
			
			

	// 		.ry-b-c {
				
	// 			box-sizing: border-box;
	// 			align-items: center;
	// 			display: flex;  
	// 			justify-content: flex-start;
	// 			align-items: center;

	// 			.item {
	// 				 transition: transform 0.3s;
	// 				background-color: #22A3D3;
	// 				flex-direction: column;
	// 				align-items: center;
	// 				text-align: left;
	// 				background-color: #22A3D3; 
	// 				display: flex;
	// 				flex-direction: column;
	// 				align-items: center;
	// 				text-align: left;
	// 				color: white;
	// 				box-sizing: border-box;
					
	// 				color: white;

	// 				.item-h {
						
	// 				}

	// 				.t {
	// 					text-align: left;
	// 				}

	// 				.s11 {
	// 					text-align: left;
	// 					opacity: 0.85;
	// 				}
	// 			}
	// 			.item:hover {
 //       transition: width 0.3s, height 0.3s;
 //       transform: scale(0.95);
       
 //      }

	// 		}
	// 	// }
	// }
	
	// @media screen and (min-width: 1200px) {
	// 	.meidumz {
	// 		width: 100%;
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: center;
	// 		padding-bottom: 80px;
	// 		padding-top: 80px;
	// 		.ry-cc {
	// 			width: 1320px;
	// 		}
	// 		// .ry-b {
	// 		// 	width: 100%;
	// 		// 	display: flex;
	// 		// 	justify-content: space-between;
	// 		// 	.ry-b-l,
	// 		// 	.ry-b-r {
	// 		// 		width: 50px;
	// 		// 		height: 50px;
	// 		// 	}
	// 			.ry-b-c {
	// 				width: 100%;
	// 				padding: 0 60px;
	// 				box-sizing: border-box;
	// 				display: flex;
	// 				justify-content: flex-start;
	// 				.item {
						
	// 					width: calc(50% - 9px);
	// 					height: 350px;
	// 					border-radius: 5px;
	// 					background-color: #39A6A7; 
	// 					margin: 0 8px;
	// 					display: flex;
	// 					flex-direction: column;
	// 					align-items: center;
	// 					text-align: left;
	// 					color: white;
	// 					padding: 30px 20px;
	// 					box-sizing: border-box;
						
	// 					.item-h {
	// 						width: 100%;
	// 						height: 160px;
	// 						margin-top: 30px;
	// 					}
	// 					.t {
	// 						width: 100%;
	// 						font-size: 16px;
	// 					}
	// 					.s11 {
	// 						width: 100%;
	// 						margin-top: 8px;
	// 						margin-top: 12px;
	// 						font-size: 14px;
	// 					}
	// 				}
	// 			}
	// 		// }
	// 	}
	
	// }
	// @media screen and (max-width: 1200px) {
	// 	.meidumz {
	// 		width: 100%;
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: center;
	// 		padding-bottom: 80px;
	// 		padding-top: 80px;
	// 		.ry-cc {
	// 			width: 100%;
	// 		}
	// 		// .ry-b {
	// 		// 	width: 100%;
	// 		// 	display: flex;
	// 		// 	justify-content: space-between;
	// 		// 	.ry-b-l,
	// 		// 	.ry-b-r {
	// 		// 		width: 40px;
	// 		// 		height: 40px;
	// 		// 	}
	// 			.ry-b-c {
	// 				width: 100%;
	// 				padding: 0 60px;
	// 				box-sizing: border-box;
	// 				display: flex;
	// 				justify-content: space-between;
	// 				.item {
	// 					width: calc(50% - 9px);
	// 					height: 240px;
	// 					border-radius: 5px;
	// 					background-color: #39A6A7; 
	// 					margin: 0 8px;
	// 					display: flex;
	// 					flex-direction: column;
	// 					align-items: center;
	// 					text-align: left;
	// 					color: white;
	// 					padding: 20px 20px;
	// 					box-sizing: border-box;
						
	// 					.item-h {
	// 						width: 100%;
	// 						height: 100px;
	// 						margin-top: 30px;
	// 					}
	// 					.t {
	// 						width: 100%;
	// 						font-size: 16px;
	// 					}
	// 					.s11 {
	// 						width: 100%;
	// 						margin-top: 8px;
	// 						margin-top: 12px;
	// 						font-size: 14px;
	// 					}
	// 				}
	// 			}
	// 		// }
	// 	}
	// }
	// @media screen and (max-width: 880px) {
	// 	.meidumz {
	// 		width: 100%;
	// 		display: flex;
	// 		flex-direction: column;
	// 		justify-content: center;
	// 		padding-bottom: 50px;
	// 		padding-top: 50px;
	// 		.ry-cc {
	// 			width: 100%;
	// 		}
	// 		// .ry-b {
	// 		// 	width: 100%;
	// 		// 	display: flex;
	// 		// 	justify-content: space-between;
	// 		// 	.ry-b-l,
	// 		// 	.ry-b-r {
	// 		// 		display: none;
	// 		// 	}
	// 			.ry-b-c {
	// 				width: 100%;
	// 				padding: 0 50px;
	// 				box-sizing: border-box;
	// 				display: flex;
	// 				justify-content: space-between;
	// 				.item {
	// 					width: 100%;
	// 					height: 280px;
	// 					border-radius: 5px;
	// 					background-color: #39A6A7; 
	// 					margin: 0 8px;
	// 					display: flex;
	// 					flex-direction: column;
	// 					align-items: center;
	// 					text-align: left;
	// 					color: white;
	// 					padding: 20px 20px;
	// 					box-sizing: border-box;
						
	// 					.item-h {
	// 						width: 100%;
	// 						height: 120px;
	// 						margin-top: 10px;
	// 					}
	// 					.t {
	// 						width: 100%;
	// 						font-size: 15px;
	// 					}
	// 					.s11 {
	// 						width: 100%;
	// 						margin-top: 8px;
	// 						font-size: 14px;
	// 					}
	// 				}
	// 			}
	// 		// }
	// 	}
	// }
</style>
